import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './component/context/UserContext';
import { ToastProvider } from './component/common/RemitAssureToast';
import { BrowserRouter, Route } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter >
    <AuthProvider>
  <ToastProvider>
    <App />
  </ToastProvider>
</AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
